import { UserType } from "@/constants";
import { getGovernmentJurisdictionOptions } from "@/hera-api/client/@tanstack/react-query.gen";
import { useAuthQuerySetup } from "@/hooks/use-auth-query-setup";
import {
  getImpersonatedGovernmentJurisdictionId,
  isOperatorGovernmentImpersonating,
} from "@/lib/government-impersonate";
import { getGovernmentUserJurisdictionId, getUserType } from "@/lib/utils";
import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";

/** JWT claim for government users, or /government/jurisdiction for impersonating operators. */
export function useGovernmentPortalJurisdictionId(enabled = true): {
  jurisdictionId: string | null;
  isLoading: boolean;
} {
  const { user } = useAuth0();
  const { isAuthSetupComplete } = useAuthQuerySetup();
  const userType = getUserType(user);
  const impersonating =
    userType === UserType.OPERATOR && isOperatorGovernmentImpersonating();

  const fromToken =
    userType === UserType.GOVERNMENT
      ? getGovernmentUserJurisdictionId(user)
      : null;
  const fromSession = impersonating
    ? getImpersonatedGovernmentJurisdictionId()
    : null;

  const shouldFetch =
    enabled &&
    isAuthSetupComplete &&
    ((userType === UserType.GOVERNMENT && !fromToken) || impersonating);

  const { data, isLoading } = useQuery({
    ...getGovernmentJurisdictionOptions(),
    enabled: shouldFetch,
  });

  return {
    jurisdictionId: fromToken || fromSession || data?.id || null,
    isLoading: shouldFetch && isLoading && !fromToken && !fromSession,
  };
}
